import type { PropsWithChildren } from 'react';
import type React from 'react';

import { DLocalContext } from './context';
import { useDLocalSDK } from './useDLocalSDK';

export const DLocalProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const dLocalSDK = useDLocalSDK();

	return <DLocalContext.Provider value={dLocalSDK}>{children}</DLocalContext.Provider>;
};
